import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {useracc, postApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import moment from 'moment';
import { DateTime } from 'luxon';
import BBCode from '../components/bbcode/bbcode';

import DJAreaSideMenu from './sidemenu';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default class DJAreaLogs extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			guests: {},
      logs: {},
		};
  };

  async componentDidMount() {
		document.title = "Admin - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		var params = new URLSearchParams();
		const x = await postApi('/api/v2/admin/logs', params);
		this.setState({logs: x.data.Logs});
	}

	componentWillUnmount() {
	}


	

	render() {
		const user = this.context;
		var uk_time = user.user.user?.timezone;
		const logs = 
      Object.keys(this.state.logs).map((e,i) => {
        return (
          <div key={i} className="col-12 pb-2">
						<div className="row ">

							{this.state.logs[e].sid > 0 &&
								<React.Fragment key={i}>
									<div className="col-12">
										<div className="p-schedule-event" style={{borderTop: '1px solid rgb(38, 38, 46)', padding: 6}}>
											<div className="row">
												<div className="p-schedule-event-image" style={{textAlign: 'center'}}>
													<img src={`https://mix365.co.uk${this.state.logs[e].avatar}`} width="84" height="84" alt="profile avatar" />
												</div>
												<div className="col">
													<div className="p-schedule-event-dj mt-2" style={{position: 'relative'}}>
														<div>{user.user.user.id===3&&<>Schedule: {this.state.logs[e].id} user: {this.state.logs[e].uid} </>}<BBCode text={this.state.logs[e].message} /></div><br />
														<Link to={this.state.logs[e].username===null?'#':`/${this.state.logs[e].username.toLowerCase().replaceAll(' ','_')}`} className="pb-4">
															{this.state.logs[e].djtitle?this.state.logs[e].djtitle:this.state.logs[e].title?this.state.logs[e].title:this.state.logs[e].username}
														</Link>{this.state.logs[e].cancelled===1 && <>&nbsp;&nbsp;Cancelled</>}<br />
														
														
														<span style={{fontWeight: '600', lineHeight: '30px'}}>
															{moment(this.state.logs[e].start*1000).format("ddd Do MMM ~ HH:mm - ")}
															{moment(this.state.logs[e].end*1000).format("HH:mm")}
															&nbsp;{DateTime.local().toFormat('ZZZZ')}&nbsp;&nbsp;
															{user.user.user?.rank>=4&&uk_time!==0&&
																<small>({moment((this.state.logs[e].start+uk_time*60*60)*1000).format("HH:mm")} - {moment((this.state.logs[e].end+uk_time*60*60)*1000).format("HH:mm")} UK)</small>
															}
															<br />
														</span>
														
														{this.state.logs[e].description && <><span style={{fontWeight: '600'}}>{this.state.logs[e].description}<br /></span></>}
															{this.state.logs[e].genres?.length > 0 &&
															<div style={{fontSize: 12, marginLeft: -5}}>
																{Object.keys(this.state.logs[e].genres).map((f,j) => {
																	return (
																		<span key={j} style={{margin: 3, paddingTop: 5, paddingRight: 10, paddingBottom: 5, paddingLeft: 10, backgroundColor: 'rgb(28, 28, 36)', borderRadius: 20, float: 'left', cursor: 'pointer'}}>{this.state.logs[e].genres[f]}</span>
																	)
																})}
																</div>
															}
														
														
														
													</div>
													
												</div>
											</div>
										</div>
									</div>
								</React.Fragment>
							}
							
							{this.state.logs[e].sid === 0 &&
								<>
									<div className="" style={{width: '120px'}}><div className="p-schedule-event-image"><img src={`https://mix365.co.uk${this.state.logs[e].avatar}`} alt="Profile Avatar" width="84" height="84" /></div></div>
									<div className="col pt-2">
										{moment(this.state.logs[e].ctime*1000).format("DD/MM/YYYY HH:mm")}
										
										{this.state.logs[e].start > 0 &&
											<>
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												{moment(this.state.logs[e].start*1000).format("ddd Do MMM ~ HH:mm - ")}
												{moment(this.state.logs[e].end*1000).format("HH:mm")}
												&nbsp;{DateTime.local().toFormat('ZZZZ')}&nbsp;&nbsp;
											</>
										}

										<br />
										{this.state.logs[e].title?this.state.logs[e].title:this.state.logs[e].username} <BBCode text={this.state.logs[e].message} />

									</div>
								</>
							}
						</div>
          </div>
        )
      })
		return (
			<Row className="dj-area">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				<Col>
					<Row>
						<div className="col-12 admin-panel-header">
							Logs
						</div>
						<div className="col-12 admin-panel-body">
							<div className="row">
								{logs}
							</div>
						</div>
					</Row>
				</Col>
			</Row>
		);
	}
}
